import { createListViewContainer } from 'factories/ListView'
import selectors from 'selectors'
import actions from 'actions/reports/inventoryTransferReport'
import Component from 'components/Reports/InventoryTransferReport'

export default createListViewContainer({ actions, selectors: selectors.inventoryTransferReport })(Component)
